var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.556 0H2.444C1.094 0 0 1.094 0 2.444v17.112C0 20.906 1.094 22 2.444 22h9.315v-8.508H8.895v-3.33h2.864V7.71c0-2.84 1.737-4.389 4.272-4.389.854-.002 1.707.042 2.557.128v2.97h-1.746c-1.38 0-1.65.653-1.65 1.616v2.12h3.3l-.429 3.331h-2.89V22h4.383C20.906 22 22 20.906 22 19.556V2.444C22 1.094 20.906 0 19.556 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.1e1142af768fcd6de2e589e5239587f3.svg";
export { ForwardRef as ReactComponent };